import { useCardsRouterContext } from '@apps/card/Card.routes';
import type { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { useRouteMatch } from '@react-router';
import { useEffect } from 'react';

type UseUpdatePdpUrlToIncludeTemplateIdArgs = {
  templateCategory: StationeryTemplateCategoryEnum;
  templateMatches: Array<{ id: string; themeId: string }>;
  themeId: string;
  enable: boolean;
};

export const useUpdatePdpUrlToIncludeTemplateId = (args: UseUpdatePdpUrlToIncludeTemplateIdArgs) => {
  const { templateMatches, templateCategory, themeId, enable } = args;
  const { routes, goToProductDetailsPage } = useCardsRouterContext();
  const isMissingTemplateIdInUrl = !useRouteMatch({ path: routes.productDetailsPageV2.paths });

  const firstTemplateId: string | undefined = templateMatches?.[0]?.id;

  useEffect(() => {
    if (enable && isMissingTemplateIdInUrl && firstTemplateId) {
      goToProductDetailsPage('wedding', templateCategory, themeId, firstTemplateId, 'replace');
    }
  }, [enable, isMissingTemplateIdInUrl, firstTemplateId, templateCategory, themeId, goToProductDetailsPage]);
};
